import { forwardRef } from 'react';
import { SignalViewerRef } from '@lmt/signal-viewer-ui';
import './InteractiveChartsViewHeader.css';
import { AddNewFileButton } from './AddNewFileButton';
import { ImportSdCardButton } from './ImportSdCardButton';
import { DemoFileSelector } from './DemoFileSelector';
import { FileInfo } from '../components/FileInfo';
import { DateSelector } from '../components/DateSelector';
import { TimeIntervalSwitcher } from '../components/TimeIntervalSwitcher';
import {
  PredefinedZoomInterval,
  ZoomIntervalSelector,
} from '../components/ZoomIntervalSelector';
import { ChannelConfigInspector } from '../components/ProfileConfiguration/ChannelsConfigInspector';
import { VersionBadge } from '../components/VersionBadge';

export type InteractiveChartsViewHeaderProps = {
  selectedZoomInterval: PredefinedZoomInterval | null;
  onZoomIntervalChange: (value: PredefinedZoomInterval | null) => void;
};

export const InteractiveChartsViewHeader = forwardRef<
  SignalViewerRef,
  InteractiveChartsViewHeaderProps
>(
  ({ selectedZoomInterval, onZoomIntervalChange }, ref) => {
    return (
      <div className='topbar'>
        <div className='topbar__row'>
          <DateSelector />
          <FileInfo />
          <div className='topbar__row-group topbar__row-group-right'>
            <DemoFileSelector />
            <AddNewFileButton />
            <ChannelConfigInspector />
          </div>
        </div>
        <div className='topbar__row'>
          <div className='topbar__row-group topbar__row-group-left'>
            <TimeIntervalSwitcher />
            <ZoomIntervalSelector
              ref={ref}
              selectedValue={selectedZoomInterval}
              onChange={onZoomIntervalChange}
            />
          </div>
          <div className='topbar__row-group topbar__row-group-right'>
            <ImportSdCardButton />
          </div>
        </div>
        <VersionBadge />
      </div>
    );
  },
);
